import { createAction, createActionGroup, emptyProps, props } from '@ngrx/store';
import { Account, Payment, PaymentCategory, SwiftCode, Transfer } from '@qvs/core';
import { OrdersPaymentRequest, Uuid } from '~/lazy/payments/pages/new-payment/models/ordersPaymentRequest';

const source = 'Payment';

export const loadPaymentRecentPayments = createAction(
  '[Payment] Load Payment Recent Payments',
  props<{ loadOnlyIfEmpty: boolean }>()
);

export const loadPaymentRecentPaymentsSuccess = createAction(
  '[Payment] Load Payment Recent Payments Success',
  props<{ payments: Payment[] }>()
);

export const loadPaymentRecentPaymentsFailure = createAction('[Payment] Load Payment Recent Payments Failure');

export const loadPaymentIfNotLoadedYet = createAction('[Payment] load payment if not loaded yet', props<{ paymentId: number }>());

export const { loadPayment, loadPaymentSuccess, loadPaymentFailure } = createActionGroup({
  source,
  events: {
    'load payment': props<{ paymentId: number }>(),
    'load payment success': props<{ payment: Payment }>(),
    'load payment failure': emptyProps()
  }
});

export const loadPaymentRecentTransfersFailure = createAction('[Payment] Load Payment Recent Transfers Failure');

export const loadPaymentRecentTransfers = createAction('[Payment] Load Payment Recent Transfers');

export const loadPaymentRecentTransfersSuccess = createAction(
  '[Payment] Load Payment Recent Transfers Success',
  props<{ transfers: Transfer[] }>()
);

export const loadPaymentSwiftCodesOnlyIfNotLoadedYet = createAction(
  '[Payment] Load Payment SwiftCodes Only If Not Loaded Yet',
  props<{ country?: string }>()
);

export const loadPaymentSwiftCodes = createAction('[Payment] Load Payment SwiftCodes', props<{ country?: string }>());

export const loadPaymentSwiftCodesSuccess = createAction(
  '[Payment] Load Payment SwiftCodes Success',
  props<{ swiftCodes: SwiftCode[] }>()
);

export const loadPaymentSwiftCodesFailure = createAction(
  '[Payment] Load Payment SwiftCodes Failure',
  props<{ country: string }>()
);

export const loadPaymentCategories = createAction('[Payment] Load Payment Categories');

export const loadPaymentCategoriesSuccess = createAction(
  '[Payment] Load Payment Categories Success',
  props<{ categories: PaymentCategory[] }>()
);

export const loadPaymentCategoriesFailure = createAction('[Payment] Load Payment Categories Failure');

export const createOrdersPaymentAskForExecution = createAction(
  '[Payment] Create Orders Payment Ask For Execution',
  props<{ ordersPaymentRequest: OrdersPaymentRequest }>()
);

export const createOrdersPaymentAskForExecutionSuccess = createAction(
  '[Payment] Create Orders Payment Ask For Execution Success',
  props<{ ordersPaymentRequest: OrdersPaymentRequest }>()
);

export const createOrdersPaymentAskForExecutionFailure = createAction(
  '[Payment] Create Orders Payment Ask For Execution Failure'
);

export const createOrdersPayment = createAction(
  '[Payment] Create Orders Payment',
  props<{ ordersPaymentRequest: OrdersPaymentRequest }>()
);

export const createOrdersPaymentSuccess = createAction(
  '[Payment] Create Orders Payment Success',
  props<{ ordersPaymentRequest: OrdersPaymentRequest }>()
);

export const createOrdersPaymentSuccessUserHasRead = createAction(
  '[Payment] Create Orders Payment Success User Has Read',
  props<{ ordersPaymentRequest: OrdersPaymentRequest; redirect?: boolean }>()
);

export const createOrdersPaymentSuccessUserHasReadSuccess = createAction(
  '[Payment] Create Orders Payment Success User Has Read Success',
  props<{ ordersPaymentRequest: OrdersPaymentRequest }>()
);

export const createOrdersPaymentFailure = createAction(
  '[Payment] Create Orders Payment Failure',
  props<{ ordersPaymentRequest: OrdersPaymentRequest }>()
);

export const createOrdersPaymentCanceled = createAction(
  '[Payment] Create Orders Payment Canceled',
  props<{ ordersPaymentRequest: OrdersPaymentRequest }>()
);

export const createOrdersPaymentCanceledSuccess = createAction(
  '[Payment] Create Orders Payment Canceled Success',
  props<{ ordersPaymentRequest: OrdersPaymentRequest }>()
);

export const authorizeOrdersPayment = createAction(
  '[Payment] Authorize Orders Payment',
  props<{ ordersPaymentRequest: OrdersPaymentRequest }>()
);

export const authorizeOrdersPaymentSuccess = createAction(
  '[Payment] Authorize Orders Payment Success',
  props<{ ordersPaymentRequest: OrdersPaymentRequest }>()
);

export const authorizeOrdersPaymentFailure = createAction(
  '[Payment] Authorize Orders Payment Failure',
  props<{ ordersPaymentRequest: OrdersPaymentRequest }>()
);

export const confirmAuthorizedOrdersPayment = createAction(
  '[Payment] Confirm Authorized Orders Payment',
  props<{ ordersPaymentRequest: OrdersPaymentRequest }>()
);

export const confirmAuthorizedOrdersPaymentSuccess = createAction(
  '[Payment] Confirm Authorized Orders Payment Success',
  props<{ ordersPaymentRequest: OrdersPaymentRequest }>()
);

export const confirmAuthorizedOrdersPaymentFailure = createAction(
  '[Payment] Confirm Authorized Orders Payment Failure',
  props<{ ordersPaymentRequest: OrdersPaymentRequest }>()
);

export const newPaymentCreatedSuccess = createAction(
  '[Payment] New Payment Created',
  props<{ ordersPaymentRequest: OrdersPaymentRequest }>()
);

export const updatePaymentOrdersRequests = createAction(
  '[Payment] Update Payment Orders Requests',
  props<{ requests: Map<Uuid, OrdersPaymentRequest> }>()
);

export const updatePaymentOrdersRequestsSuccess = createAction(
  '[Payment] Update Payment Orders Requests Success',
  props<{ requests: Map<Uuid, OrdersPaymentRequest> }>()
);

export const updatePaymentOrdersRequestsFailure = createAction(
  '[Payment] Update Payment Orders Requests Failure',
  props<{ requests: Map<Uuid, OrdersPaymentRequest> }>()
);

export const loadSwiftCodeFromIban = createAction('[Payment] Load Swift Code From Iban', props<{ iban: string }>());

export const loadSwiftCodeFromIbanSuccess = createAction(
  '[Payment] Load Swift Code From Iban Success',
  props<{ iban: string; swiftCode: SwiftCode }>()
);

export const loadSwiftCodeFromIbanFailure = createAction('[Payment] Load Swift Code From Iban Failure');

export const paymentReturnFromDeepLinkSuccess = createAction('[Payment] Return From Deep Link Success');

export const loadSwiftCodesForAccountsFailure = createAction(
  '[Payments] Load Swift Codes For Accounts Failure',
  props<{ error?: any }>()
);

export const loadSwiftCodesForAccountsSuccess = createAction(
  '[Payments] Load Swift Codes For Accounts Success',
  props<{ updatedAccounts: Account[] }>()
);
